import { AttainmentWithDates } from 'types/interfaces/Attainment';

export const EmployeeAttainmentTemplate: AttainmentWithDates = {
  id: 0,
  attainmentId: 0,
  startDate: '',
  endDate: '',
  name: '',
  duration: false,
};
